import FetchCall from '../local_fetch_call'

const cartChangeEventName = 'order-updated'

const cartChangeElement = () => {
  return document.getElementById('navCartLink')
}

const cartChangeNotification = () => {
  let div = cartChangeElement()

  if (div) {
    let evt = document.createEvent('Event')
    evt.initEvent(cartChangeEventName, true, true)
    div.dispatchEvent(evt)
  }
}

const csrfToken = () => {
  let tok = document.getElementsByTagName('meta')['csrf-token']
  if (tok) { // csrf-token is null in testing
    return tok.getAttribute('content')
  } else {
    return null
  }
}

export default {

  async addContractedToCart(itemId, body) {

    let res = await FetchCall.fetchWithLocale(
      `/cart/items/${itemId}/order_item_hotels`,
      'POST',
      body
    )

    if (res.id) {
      cartChangeNotification()
    }
    return res
  },

  addDiscount(discountCode) {
    return FetchCall.fetchWithoutLocale('/api/discounts.json', 'POST', discountCode).
      then(res => {
        if (res.updated == true) { cartChangeNotification() }
        return res
      })
  },

  addH4HHotelToCart(itemId, body){
    return FetchCall.fetchWithLocale(
      `/cart/items/${itemId}/order_item_h4h_hotels`,
      'POST',
      body
    )
      .then(item => {
        if (item.id) { cartChangeNotification() }
        return item
      })
  },

  cartChangeElement() {
    return cartChangeElement()
  },

  cartChangeEventName() {
    return cartChangeEventName
  },

  changeOrder(body, displayUpdatingIcon=true) {
    return FetchCall.fetchWithLocale('/cart.json', 'PUT', body).
      then(order => {
        if (order.id && displayUpdatingIcon) { cartChangeNotification() }
        return order
      })
  },

  changeOrderItem(orderItemId, method, body) {
    return FetchCall.fetchWithLocale(`/cart/items/${orderItemId}.json`, method, body).
      then(item => {
        if (item.id) { cartChangeNotification() }
        return item
      })
  },

  checkout(checkoutParams) {
    return FetchCall.fetchWithLocale('/cart/charges.json', 'POST', checkoutParams).
      then(order => { return order })
  },

  checkoutConfirm(checkoutConfirmParams) {
    return FetchCall.fetchWithLocale('/cart/charges/confirms.json', 'POST', checkoutConfirmParams).
      then(order => { return order })
  },

  createOrderItem(body) {
    return FetchCall.fetchWithLocale('/cart/items.json', 'POST', body).
      then(item => {
        if (item.id) { cartChangeNotification() }
        return item
      })
  },

  deleteContractedHotelItem(orderItemId, hotelId, method, body){
    return FetchCall.fetchWithLocale(`/cart/items/${orderItemId}/order_item_hotels/${hotelId}.json`, method, body).
      then(item => {
        if (item.id) { cartChangeNotification() }
        return item
      })
  },

  deleteH4hHotelItem(orderItemId, hotelId, method, body){
    return FetchCall.fetchWithLocale(`/cart/items/${orderItemId}/order_item_h4h_hotels/${hotelId}.json`, method, body).
      then(item => {
        if (item.id) { cartChangeNotification() }
        return item
      })
  },

  getAddOnItems() {
    return FetchCall.fetchWithLocale('/cart/add_ons.json', 'GET', null).
      then(addOns => { return addOns })
  },

  getOrder() {
    return FetchCall.fetchWithLocale('/cart.json', 'GET', null).
      then(order => { return order })
  },

  async updateGuestUser(email) {
    return fetch('/customers/guests.json', {
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': csrfToken()
      },
      method: 'PUT',
      body: JSON.stringify({
        email: email
      })
    })
  },

  getProtectGroupInfo() {
    return FetchCall.fetchWithLocale('/cart/protect_group_info.json', 'GET', null)
  }
}
